/*
 * Public API Surface of ngx-player-video-create
 */

export * from './lib/ngx-player-video-create.service';
export * from './lib/ngx-player-video-create/ngx-player-video-create.component';
export * from './lib/ngx-player-video-create.module';
